import React, { useContext } from 'react';

import { HeaderSlotContext } from './AppShell/HeaderSlotContext';

export const SCROLLBAR_SIZE = 10;

export interface LayoutProps {
  title?: string;
  hasNavbar?: boolean;
  showSearchbar?: boolean;
  showBreadCrumb?: boolean;
  BreadCrumbComponent?: React.FC;
  disableGutters?: boolean;
  hasSidebar?: boolean;
  showNavbarAuthActions?: boolean;
  headerComponent?: React.ReactNode;
  hasAppBar?: boolean;
  ignoreHeaderPadding?: boolean;
}

/**
 * Sets header in AppShell's header slot and renders children. Use when you need
 * to inject a header (e.g. breadcrumb + actions) without wrapping in full
 * PageShell (e.g. embedded editor, stepper pages).
 */
export const HeaderSlotLayout: React.FC<LayoutProps> = ({
  children,
  headerComponent,
  ignoreHeaderPadding = false,
}) => {
  const headerSlotCtx = useContext(HeaderSlotContext);

  const setHeader = headerSlotCtx?.setHeader;
  const clearHeader = headerSlotCtx?.clearHeader;
  const setHeaderPadding = headerSlotCtx?.setHeaderPadding;

  React.useEffect(() => {
    if (!setHeader || !clearHeader || !setHeaderPadding) return;
    if (headerComponent !== undefined) {
      setHeader(headerComponent);
    }
    setHeaderPadding(ignoreHeaderPadding);
    return () => {
      clearHeader();
      setHeaderPadding(false);
    };
  }, [
    headerComponent,
    ignoreHeaderPadding,
    setHeader,
    clearHeader,
    setHeaderPadding,
  ]);

  return <>{children}</>;
};
